export default function Description({ className, children, whitespace = 'whitespace-pre-wrap' }) {
  return (
    <div className={ cn('text-gray-900 font-normal tracking-widest', className, whitespace) }>
      <div className='leading-6'>{ children }</div>
    </div>
  )
}
